<template>
  <div>
    <!-- LUX Onboarding -->
    <div
      class="page-content__header-description"
      style="display: flex; width: 89%; margin-left: auto; margin-right: auto;"
    >
      <h2 style="flex: 1; align-items: center;">LUX Onboarding</h2>
      <div
        v-if="usertype != 'customer'"
        style="display: flex; margin-top: 16px;"
      >
        <!-- Create user button -->
        <span style="flex: 1;">
          <router-link class="btn btn-primary" to="/lux-onboarding/create"
            >Create User</router-link
          >
        </span>
      </div>
    </div>
    <!-- Total Lux power -->
    <div style="width: 89%; margin-left: auto; margin-right: auto;">
      <p style="text-align: right; color: orange;">
        Total energy generated: {{ luxTotalEnergy }}kWh
      </p>
    </div>
    <!-- The bue-Table -->
    <div class="main-container" style="width: 90%; margin: auto;">
      <div>
        <vue-good-table
          :lineNumbers="true"
          :columns="fields"
          :rows="getUsers"
          :search-options="{
            enabled: true,
            searchFn: searchTable,
            externalQuery: searchTerm
          }"
          :pagination-options="{ enabled: true }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'firstName'">
              {{ props.row.user ? props.row.user.firstName : "----" }}
            </span>
            <span v-if="props.column.field == 'lastName'">
              {{ props.row.user ? props.row.user.lastName : "----" }}
            </span>
            <span v-if="props.column.field == 'deviceId'">
              {{ props.row.deviceId ? props.row.deviceId : "----" }}
            </span>

            <span v-if="props.column.field == 'serialNumbers'">
              {{ props.row.serialNumbers ? props.row.serialNumbers : "----" }}
            </span>

            <span v-if="props.column.field == 'Version'">
              {{ props.row.Version ? props.row.Version : "----" }}
            </span>

            <span v-if="props.column.field == 'paymentType'">
              {{ props.row.paymentType ? props.row.paymentType : "----" }}
            </span>
            <span v-if="props.column.field == 'actions'">
              <router-link
                :to="{
                  name: 'LuxDeviceUpdate',
                  params: {
                    exportDeviceid: props.row.deviceId ? props.row.deviceId : 0
                  }
                }"
              >
                <i class="fa fa-edit"></i> &nbsp;
              </router-link>

              <button
                class="red-border"
                @click="
                  deleteModal(props.row.deviceId ? props.row.deviceId : '----')
                "
              >
                <i class="fa fa-trash"></i>
              </button>
            </span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>
        </vue-good-table>

        <modal name="my-first-modal">
          <div class="form" style="width: 80%;">
            <h4>
              Are you sure you want to delete User with the deviceID -
              {{ DeviceID }}?
            </h4>

            <div class="row">
              <button type="submit" class="button-delete" @click="deleteDevice">
                Delete
              </button>
              <button type="submit" class="button-cancel" @click="cancel">
                Cancel
              </button>
            </div>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "Jan_Feb_Mar_Apr_May_June_July_Aug_Sept_Oct_Nov_Dec".split("_")
});

const items = [];
export default {
  name: "ListLuxUsers",
  components: {},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      searchTerm: "",
      luxTotalEnergy: "",
      editOffCanvas: false,
      isLoading: false,
      idSelected: "",
      DeviceID: "",
      regParams: {},
      usertype: localStorage.roleType,
      selectOption: {
        enabled: true
      },
      items: items,

      fields: [
        {
          field: "deviceId",
          label: "Device ID",
          sortable: "true"
        },
        {
          field: "serialNumbers",
          label: "Serial Number(s)",
          sortable: "true"
        },
        {
          field: "Version",
          label: "System Version",
          sortable: "true"
        },
        {
          field: "paymentType",
          label: "Payment Type",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Actions"
        }
      ],
      getUsers: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15]
    };
  },
  computed: {
    // ...mapGetters(["getUsers"])
  },
  methods: {
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
    deleteModal(deviceIDdata) {
      this.DeviceID = deviceIDdata;
      this.show();
    },
    cancel() {
      this.hide();
      this.DeviceID = "";
    },
    deleteDevice(e) {
      e.preventDefault();

      const LuxHTTP = this.$httpUtils.LUXHTTP;
      let url = `devices/${this.DeviceID}`;
      LuxHTTP.delete(url, this.DeviceID)
        .then(res => {
          this.showSuccessMsg({ message: "Device Deleted!" });
          this.init();
          this.hide();
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    totalEnergy() {
      const LuxHTTP = this.$httpUtils.LUXHTTP;
      let url = `/inverters/total-energy-generated`;

      LuxHTTP.get(url)
        .then(response => {
          this.luxTotalEnergy = response.data.data;
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    },
    init() {
      const LuxHTTP = this.$httpUtils.LUXHTTP;
      let url = `/devices`;

      LuxHTTP.get(url)
        .then(response => {
          this.getUsers = response.data.data;
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    }
  },
  async mounted() {
    this.init();
    this.totalEnergy();
  }
};
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

.form {
  margin: 100px auto;
}

h4 {
  font-weight: 600;
  color: #6a707e;
  border: none;
  text-align: center;
}

.row {
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-delete {
  padding: 5px;
  color: white;
  border-color: red;
  background: red;
  width: 200px;
}

.red-border {
  border: 2px solid red;
  width: 30px;
}

.button-cancel {
  padding: 5px;
  color: #269af1;
  background: white;
  border-color: #269af1;
  width: 200px;
}

table th,
table th span {
  font-size: 0.7em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/luxOnboarding/ListLuxUsers.vue